/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { Modal } from '@mui/material';
import ModalContainer from 'components/ModalContainer';
import styles from './LocationModal.module.scss';
import { Button } from 'tt-ui-lib/core';
import { Map } from '../../../../../../modules/tt-map';

const DEFAULT_CENTER = { lat: 47.368702, lng: 8.537458 };

const LocationModal = ({
  isModelOpen,
  handleClose,
  setIsOpen,
  coordinates,
  setCoordinates,
  setAddress,
  address,
  setLocationData,
  setValue,
  title,
  background,
  isJoint,
  isProfileEditing,
  showSearch,
  isEditable,
  zoom,
}) => {
  const mapApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
  const [tempAddress, setTempAddress] = useState(null);
  const [tempCoordinates, setTempCoordinates] = useState();
  const [tempLocationData, setTempLocationData] = useState(null);

  useEffect(() => {
    setTempCoordinates(coordinates || DEFAULT_CENTER);
  }, [coordinates]);

  const onCancelClick = (savedAddress) => {
    if (savedAddress) {
      setIsOpen(false);
    } else {
      setTempCoordinates(null);
      setTempAddress(null);
      setTempLocationData(null);
      setCoordinates(null);
      setAddress(null);
      setLocationData(null);
      setIsOpen(false);
    }
  };

  const onApplyClick = () => {
    setCoordinates(tempCoordinates);
    setAddress(tempAddress);
    setLocationData(tempLocationData);
    if (setValue) {
      setValue('location', { address: tempAddress, data: tempLocationData });
    }
    setTempLocationData(null);
    setTempCoordinates(null);
    setTempAddress(null);
    if (setValue) {
      setValue('location', tempAddress);
    }
    setIsOpen(false);
  };

  return (
    <Modal
      open={isModelOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      onClose={() => {
        if (isJoint) {
          handleClose(setIsOpen);
        }
      }}
      classes={{
        root: isJoint || isProfileEditing ? styles.modalRoot : '',
      }}
      BackdropProps={{ style: { backgroundColor: 'transparent' } }}
    >
      <ModalContainer
        background={background || 'rgba(255, 255, 255, 0.4)'}
        onClose={() => {
          if (isJoint) {
            handleClose(setIsOpen);
          }
        }}
        isMapContainer
      >
        {title && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.mapWrapper}>
          <Map
            coordinates={tempCoordinates}
            address={address}
            getCoordinates={(c) => setTempCoordinates(c)}
            getAddress={setTempAddress}
            getAddressData={setTempLocationData}
            apiKey={mapApiKey}
            isEditable={isEditable}
            showSearch={showSearch}
            zoom={zoom}
          />
        </div>
        {!isJoint && (
          <div className={styles.buttonsWrapper}>
            <Button type="default" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button
              type="primary"
              isSubmit
              disabled={!tempCoordinates && !tempAddress}
              onClick={onApplyClick}
            >
              Apply
            </Button>
          </div>
        )}
      </ModalContainer>
    </Modal>
  );
};

export default LocationModal;
